import React from "react";
import { Factory, Truck, FlaskConical, Snowflake } from "lucide-react";

export const TYPE_ICON = {
  stationary_combustion: Factory, mobile_combustion: Truck,
  process_emissions: FlaskConical, fugitive_emissions: Snowflake,
};

export const STATUS_META = {
  active: { label: "Active", cls: "bg-[#00E65B]/15 text-[#00E65B] border border-[#00E65B]/30" },
  screened_not_material: { label: "Screened — not material", cls: "bg-muted text-muted-foreground border border-border" },
  not_yet_screened: { label: "Not yet screened", cls: "bg-[#FFB800]/15 text-[#FFB800] border border-[#FFB800]/30" },
};

export const STATUS_OPTS = [
  { v: "active", l: "Active — material" },
  { v: "screened_not_material", l: "Screened — not material" },
  { v: "not_yet_screened", l: "Not yet screened" },
];

export const TIER_OPTS = ["A", "B", "C", "D"];

export function StatusChip({ status, testid }) {
  const m = STATUS_META[status] || STATUS_META.not_yet_screened;
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-medium ${m.cls}`} data-testid={testid}>
      {m.label}
    </span>
  );
}

export function currentMonth() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}
